import { useState, useEffect } from 'react';
import { checkResetToken, applyResetPassword } from '../api';

export default function ResetPasswordPage({ token, onDone }) {
  const [valid, setValid]     = useState(null);
  const [username, setUsername] = useState('');
  const [pwd, setPwd]         = useState('');
  const [pwd2, setPwd2]       = useState('');
  const [error, setError]     = useState('');
  const [done, setDone]       = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkResetToken(token)
      .then(r => { setValid(true); setUsername(r.username||''); })
      .catch(() => setValid(false));
  }, [token]);

  async function submit(e) {
    e.preventDefault(); setError('');
    if (pwd.length < 6)  return setError('Minimum 6 caractères');
    if (pwd !== pwd2)    return setError('Les mots de passe ne correspondent pas');
    setLoading(true);
    try { await applyResetPassword(token, pwd); setDone(true); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  if (valid === null) return <div style={{ padding:40, textAlign:'center', color:'#8b949e' }}>Vérification…</div>;

  return (
    <div style={{ padding:'44px 24px', maxWidth:380, margin:'0 auto' }}>
      <div style={{ textAlign:'center', marginBottom:26 }}>
        <img src="/img/logo-equipote.png" alt="Équipote" style={{ height:40, width:'auto', margin:'0 auto 18px', display:'block' }} />
        <div style={{ fontSize:34 }}>{done ? '✅' : valid ? '🔑' : '⚠️'}</div>
        <h1 style={{ fontFamily:'Barlow Condensed', fontSize:24, fontWeight:800, marginTop:8 }}>
          {done ? 'Mot de passe modifié' : valid ? 'Nouveau mot de passe' : 'Lien invalide'}
        </h1>
        {valid && !done && username && <p style={{ color:'#8b949e', fontSize:12, marginTop:4 }}>Compte : {username}</p>}
      </div>

      {!valid && (
        <>
          <p style={{ textAlign:'center', fontSize:13, color:'#8b949e', lineHeight:1.7 }}>
            Ce lien a expiré ou a déjà été utilisé. Refais une demande depuis la page de connexion.
          </p>
          <button className="btn btn-primary" style={{ marginTop:20 }} onClick={onDone}>Retour</button>
        </>
      )}

      {valid && done && (
        <>
          <p style={{ textAlign:'center', fontSize:13, color:'#8b949e' }}>Tu peux maintenant te connecter.</p>
          <button className="btn btn-primary" style={{ marginTop:20 }} onClick={onDone}>Se connecter</button>
        </>
      )}

      {valid && !done && (
        <form onSubmit={submit}>
          <div className="form-group">
            <label>Nouveau mot de passe</label>
            <input type="password" value={pwd} onChange={e=>setPwd(e.target.value)} autoComplete="new-password" required />
          </div>
          <div className="form-group">
            <label>Confirmer</label>
            <input type="password" value={pwd2} onChange={e=>setPwd2(e.target.value)} autoComplete="new-password" required />
          </div>
          {error && <div style={{ background:'rgba(var(--danger-rgb),0.1)', border:'1px solid rgba(var(--danger-rgb),0.3)',
            borderRadius:8, padding:'10px 14px', color:'var(--danger)', fontSize:13, marginBottom:14 }}>{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Enregistrement…' : 'Valider'}
          </button>
        </form>
      )}
    </div>
  );
}
